import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=0ecd16a3&scoped=true&"
import script from "./Reminders.vue?vue&type=script&lang=js&"
export * from "./Reminders.vue?vue&type=script&lang=js&"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=0ecd16a3&prod&scoped=true&lang=css&"
import style1 from "./Reminders.vue?vue&type=style&index=1&id=0ecd16a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd16a3",
  null
  
)

export default component.exports